import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6a3b4899&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3b4899",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a3b4899')) {
      api.createRecord('6a3b4899', component.options)
    } else {
      api.reload('6a3b4899', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=6a3b4899&scoped=true&", function () {
      api.rerender('6a3b4899', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/SettingsDivisionMiscellaneous/Components/Index.vue"
export default component.exports